module.exports = "/static/assets/754baa103c2ac348fe5d6ecca59bea5a.png";